import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import { cloneDeep } from 'lodash'
// Import the action creators
import * as Actions from './actions'

export const getListTrainings = () => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { trainingMasterModuleList: { resultTable: { appliedFilter } } } = getState()
    let updateSortModel = dispatch(convertToSearchModel(appliedFilter));

    ApiService.get(Path.LIST, updateSortModel)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updateTrainingList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

// TRAINING MASTER MODULE LIST ACTIONS/ACTION OPERATIONS
export const applySearchFilters = (searchModel) => (dispatch) => {
    // Page will always be zero upon searching
    dispatch(Actions.changeFilterPage(1))

    // dispatch the search filters
    dispatch(Actions.applyFilters(searchModel))

    // get data from server and update results
    dispatch(getListTrainings())
}

export const resetSearchResults = () => (dispatch) => {
    // reset filter
    dispatch(Actions.resetResults())
    // Update the list
    dispatch(getListTrainings())
}

export const resetFilters = () => (dispatch, getState) => {
    dispatch(Actions.resetFilters())
    return new Promise((resolve, reject) => {
        const { trainingMasterModuleList: { searchFilter } } = getState()
        resolve(searchFilter)
    })
}

export const changePage = (newPage) => (dispatch) => {
    // dispatch change filter page
    dispatch(Actions.changeFilterPage(newPage))
    // Update the list
    dispatch(getListTrainings())
}

export const changeRowsPerPage = (pageModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterRowsPerPage(pageModel))
    // Update list
    dispatch(getListTrainings())
}

export const changeSort = (sortModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterSort(sortModel))
    // Update list
    dispatch(getListTrainings())
}

// TRAINING MASTER MODULE ADD ACTION OPERATIONS
export const createTraining = (data) => (dispatch, getState) => {
    const { trainingMasterModuleList: { alertCreate } } = getState()
    let nAlert = { ...alertCreate }
    dispatch(Actions.showLoading(true))
    
    return ApiService.post(Path.ROOT, data)
        .then((response) => {
            if (response) {

                let title = 'Create Success'
                const { message } = response.data
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    title = 'Create Failed'
                    goBackToList = false
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                    onHide: () => {
                        dispatch(Actions.hideAddAlert())
                    }
                }
                dispatch(getListTrainings());
            }
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
            dispatch(Actions.updateAddAlertData(nAlert))
        })
}

// TRAINING MASTER MODULE DETAIL/UPDATE ACTION OPERATIONS
export const getTrainingsById = (id, mode) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    return ApiService.get(Path.ROOT + '/' + id)
        .then((response) => {
            dispatch(Actions.setTrainingsDetail(response.data, mode))
            return response.data;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const updateTraninings = (ID) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    const { trainingMasterModuleList: { updateValues } } = getState()
    const { auth } = getState()
    let userId = auth.credentials.userId
    let companyId = auth.credentials.companyId

    let updatedData = cloneDeep(updateValues);
    updatedData.UserID = userId;
    updatedData.companyID = companyId;
    updatedData.ID = ID;

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.put(Path.ROOT + '/' + ID, updatedData)
        .then((response) => {
            if (response) {
                let title = 'Update Success'
                const { message } = response.data
                let goBackToList = true
                if (response.data.returnCode <= 0) {
                    title = 'Update Failed'
                    goBackToList = false
                }

                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message != null ? message : 'Interviews successfully updated.',
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                    onHide: () => {
                        dispatch(Actions.hideListAlert())
                        dispatch(resetSearchResults())
                    }
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
            dispatch(Actions.setListAlert(returnValue.alertData))
        })
}   

export const deleteTraining = (data) => (dispatch) => {
    dispatch(Actions.isLoading(true))

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update Success',
            content: 'Training successfully deleted.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.delete(Path.ROOT + '/' + data)
        .then((response) => {
            if (response) {
                let title = 'Delete Success'
                const { message } = response.data
                if (response.data.returnCode <= 0) {
                    title = 'Delete Failed'
                }
                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const getTrainingCategory = (company) => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.TRAINING_CATEGORY, { company })
        .then((response) => {
            let listData = [];
            if (response) {
                const { data } = response;
                listData = data.map(((item) => ({ name: item.name, value: item.value })));
                return listData
            } else {
                listData = data;
            };
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
        });
}

export const convertToSearchModel = (data) => (dispatch, getState) =>{ 
    const { auth } = getState()
    let userId = auth.credentials.userId
    let companyId = auth.credentials.companyId
    return {
        ...data,
        UserID: userId,
        CompID: companyId,
        Pagination: {
            Page: (data.Pagination.Page - 1 < 0) ? 0 : data.Pagination.Page - 1,
            PageSize: data.Pagination.PageSize,
        },
    }
}





